import type {ProductFilters} from './query';

export type FilterParams = {
	merkevare?: string[];
	farge?: string[];
	storrelse?: string[];
	kjoretoy?: string[];
	merke?: string[];
	modell?: string[];
};

export type FilterSearchParams = {
	merkevare?: string[] | string;
	farge?: string[] | string;
	storrelse?: string[] | string;
	kjoretoy?: string[] | string;
	merke?: string[] | string;
	modell?: string[] | string;
};

export const createSearchParamsFromFilterSearchParams = (
	filterSearchParams: FilterSearchParams,
) => {
	const params = Object.entries(filterSearchParams).reduce((acc, [key, value]) => {
		if (Array.isArray(value)) {
			for (const v of value) {
				acc.append(key, v);
			}
		} else {
			acc.append(key, value);
		}

		return acc;
	}, new URLSearchParams());

	return params;
};

export function intersectMatchesAndFilters(
	matches: ProductFilters,
	filters: ProductFilters,
): ProductFilters | null {
	if (matches.colorIds && filters.colorIds && filters.colorIds.length > 0) {
		matches.colorIds = matches.colorIds.filter((colorId) =>
			(filters.colorIds ?? []).includes(colorId),
		);

		// If there are no matching colors left, the product doesn't match the selected color filters:
		if (matches.colorIds.length === 0) {
			return null;
		}
	}

	if (matches.brandIds && filters.brandIds && filters.brandIds.length > 0) {
		matches.brandIds = matches.brandIds.filter((brandId) =>
			(filters.brandIds ?? []).includes(brandId),
		);

		// If there are no matching brands left, the product doesn't match the selected brand filters:
		if (matches.brandIds.length === 0) {
			return null;
		}
	}

	if (matches.vehicleTypesIds && filters.vehicleTypesIds && filters.vehicleTypesIds.length > 0) {
		matches.vehicleTypesIds = matches.vehicleTypesIds.filter((typeId) =>
			(filters.vehicleTypesIds ?? []).includes(typeId),
		);

		// If there are no matching vehicle types left, the product doesn't match the selected vehicle type filters:
		if (matches.vehicleTypesIds.length === 0) {
			return null;
		}
	}

	if (matches.vehicleBrandIds && filters.vehicleBrandIds && filters.vehicleBrandIds.length > 0) {
		matches.vehicleBrandIds = matches.vehicleBrandIds.filter((brandId) =>
			(filters.vehicleBrandIds ?? []).includes(brandId),
		);

		// If there are no matching vehicle brands left, the product doesn't match the selected vehicle brand filters:
		if (matches.vehicleBrandIds.length === 0) {
			return null;
		}
	}

	if (matches.vehicleModelIds && filters.vehicleModelIds && filters.vehicleModelIds.length > 0) {
		matches.vehicleModelIds = matches.vehicleModelIds.filter((modelId) =>
			(filters.vehicleModelIds ?? []).includes(modelId),
		);

		// If there are no matching vehicle models left, the product doesn't match the selected vehicle model filters:
		if (matches.vehicleModelIds.length === 0) {
			return null;
		}
	}

	return matches;
}
